import { jsxs as r, jsx as a } from "react/jsx-runtime";
function e(s) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "42",
      height: "42",
      viewBox: "0 0 37 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...s,
      children: [
        /* @__PURE__ */ a("mask", { id: "mask0_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ a("g", { mask: "url(#mask0_204047_1574)", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L28.2806 8.44208L22.8469 0.715088Z",
            fill: "#0F9D58"
          }
        ) }),
        /* @__PURE__ */ a("mask", { id: "mask1_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ a("g", { mask: "url(#mask1_204047_1574)", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M9.80603 24.448V40.4539H27.1938V24.448H9.80603ZM17.4132 38.2462H11.9795V35.4866H17.4132V38.2462ZM17.4132 33.8308H11.9795V31.0711H17.4132V33.8308ZM17.4132 29.4153H11.9795V26.6557H17.4132V29.4153ZM25.0203 38.2462H19.5866V35.4866H25.0203V38.2462ZM25.0203 33.8308H19.5866V31.0711H25.0203V33.8308ZM25.0203 29.4153H19.5866V26.6557H25.0203V29.4153Z",
            fill: "#F1F1F1"
          }
        ) }),
        /* @__PURE__ */ a("mask", { id: "mask2_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ a("g", { mask: "url(#mask2_204047_1574)", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M23.8005 12.9927L35.8877 25.2676V13.9613L23.8005 12.9927Z",
            fill: "url(#paint0_linear_204047_1574)"
          }
        ) }),
        /* @__PURE__ */ a("mask", { id: "mask3_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ a("g", { mask: "url(#mask3_204047_1574)", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088V10.6498C22.8469 12.4794 24.3059 13.9614 26.1071 13.9614H35.8877L22.8469 0.715088Z",
            fill: "#87CEAC"
          }
        ) }),
        /* @__PURE__ */ a("mask", { id: "mask4_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ a("g", { mask: "url(#mask4_204047_1574)", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M4.37239 0.715088C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V4.30262C1.11218 2.48126 2.57927 0.991052 4.37239 0.991052H22.8469V0.715088H4.37239Z",
            fill: "rgb(var(--background-secondary))",
            "fill-opacity": "0.2"
          }
        ) }),
        /* @__PURE__ */ a("mask", { id: "mask5_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ a("g", { mask: "url(#mask5_204047_1574)", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M32.6275 49.0088H4.37239C2.57927 49.0088 1.11218 47.5186 1.11218 45.6973V45.9732C1.11218 47.7946 2.57927 49.2848 4.37239 49.2848H32.6275C34.4206 49.2848 35.8877 47.7946 35.8877 45.9732V45.6973C35.8877 47.5186 34.4206 49.0088 32.6275 49.0088Z",
            fill: "#263238",
            "fill-opacity": "0.2"
          }
        ) }),
        /* @__PURE__ */ a("mask", { id: "mask6_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ a("g", { mask: "url(#mask6_204047_1574)", children: /* @__PURE__ */ a(
          "path",
          {
            d: "M26.1071 13.9615C24.3059 13.9615 22.8469 12.4795 22.8469 10.6499V10.9259C22.8469 12.7555 24.3059 14.2374 26.1071 14.2374H35.8877V13.9615H26.1071Z",
            fill: "#263238",
            "fill-opacity": "0.1"
          }
        ) }),
        /* @__PURE__ */ a(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "url(#paint1_radial_204047_1574)"
          }
        ),
        /* @__PURE__ */ r("defs", { children: [
          /* @__PURE__ */ r(
            "linearGradient",
            {
              id: "paint0_linear_204047_1574",
              x1: "628.226",
              y1: "118.386",
              x2: "628.226",
              y2: "1240.65",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ a("stop", { "stop-color": "#263238", "stop-opacity": "0.2" }),
                /* @__PURE__ */ a("stop", { offset: "1", "stop-color": "#263238", "stop-opacity": "0.02" })
              ]
            }
          ),
          /* @__PURE__ */ r(
            "radialGradient",
            {
              id: "paint1_radial_204047_1574",
              cx: "0",
              cy: "0",
              r: "1",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "translate(111.283 96.7101) scale(5607.5 5695.85)",
              children: [
                /* @__PURE__ */ a("stop", { "stop-color": "rgb(var(--background-secondary))", "stop-opacity": "0.1" }),
                /* @__PURE__ */ a("stop", { offset: "1", "stop-color": "rgb(var(--background-secondary))", "stop-opacity": "0" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
export {
  e as GoogleSheetsIcon
};
